<template>
    <div class="ah-page current-expenditure-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>經常性費用設定</h1>
                    </div>
                    <div class="actions">
                        <el-button
                            v-if="!isQR()"
                            @click="
                                $router.push({
                                    name: 'current-expenditure-add'
                                })
                            "
                            type="highlight"
                            >新增經常性費用</el-button
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body">
                    <el-table-draggable handle=".handle" :animate="300" @drop="onChangeSort">
                        <el-table :data="datas" @row-click="handleDataRowClick" class="ah-el-data-table row-click" v-loading="status == 'loading'" empty-text="沒有資料">
                            <el-table-column width="45px">
                                <template slot-scope="">
                                    <div class="handle">
                                        <div v-for="i in 3" :key="i" />
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="iteM_NAM" label="支出名稱">
                                <template slot-scope="scope">
                                    <div class="strong">
                                        {{ scope.row.iteM_NAM }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="金額上限提示" align="right">
                                <template slot-scope="scope">
                                    <Money :v="scope.row.amT_E" />
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-table-draggable>
                </div>
            </div>
        </div>
        <EditDialog v-if="showEditDialog" :visible="showEditDialog" @close="closeDialog" />
    </div>
</template>
<script>
import _ from 'lodash';
import ElTableDraggable from 'element-ui-el-table-draggable';
import EditDialog from './EditDialog.vue';

export default {
    name: 'CurrentExpend',
    components: {
        EditDialog,
        ElTableDraggable,
    },
    data() {
        return {
            showEditDialog: false,
            PageNum: 1,
            PageSize: 25,
            status: '',
            datas: [],
            originalData: [],
            year: '',
            errorMsg: '',
            totalDataCount: 0,
            selectedItem: {},
            yearList: [],
        };
    },
    created() {
        this.updateData();
    },
    methods: {
        handleDataRowClick(data) {
            this.$router.push({
                name: 'current-expenditure-edit',
                params: { sno: data.sno },
            });
        },
        closeDialog(refresh) {
            if (refresh) this.updateData();
            this.showEditDialog = false;
        },
        updateData() {
            this.status = 'loading';
            this.$api({
                url: 'CurrentExpenditureSettingPage/GetList',
                params: { PageNum: this.PageNum, PageSize: this.PageSize },
                method: 'GET',
            }).then((resp) => {
                this.status = 'success';
                this.datas = resp.data.options;
                this.originalData = [...this.datas];
                this.totalDataCount = resp.data.totalNum;
            });
        },
        async onChangeSort() {
            const sorted = _.map(this.datas, (o, i) => ({
                sno: o.sno,
                sot: i,
            }));
            this.status = 'loading';
            try {
                await this.$api({
                    url: 'CurrentExpenditureSettingPage/UpdateSort',
                    method: 'POST',
                    data: { items: sorted },
                });
            } catch (e) {
                this.datas = [...this.originalData];
            } finally {
                this.status = 'success';
            }
        },
    },
};
</script>
<style lang="scss" scoped="">
@import "@/assets/scss/vars.scss";
.handle {
    position: relative;
    width: 18px;
    height: 30px;
    margin: auto;
    > * {
        position: absolute;
        width: 100%;
        height: 2px;
        background-color: #ddd;
        transform: translateY(-50%);
    }
    :nth-child(1) {
        top: calc(50% + 5px);
    }
    :nth-child(2) {
        top: 50%;
    }
    :nth-child(3) {
        top: calc(50% - 5px);
    }
}
</style>
